import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login/Login";
import Dashboard from "../src/components/Home/DashBoard";
import CheckIn from "./components/Home/Checkin";
import CheckOut from "./components/Home/Checkout.jsx";

 

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/" replace />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"          element={<Login />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/checkin"   element={<PrivateRoute><CheckIn /></PrivateRoute>} />
        <Route path="/checkout"  element={<PrivateRoute><CheckOut /></PrivateRoute>} />
        <Route path="*"          element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}